var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurkey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M277.992,211.684l15.663,20.489l24.456-8.186c1.368-0.458,2.531,1.089,1.712,2.276l-14.647,21.227 l15.343,20.73c0.858,1.159-0.253,2.743-1.635,2.331l-24.715-7.37l-14.974,20.998c-0.837,1.174-2.687,0.607-2.722-0.835 l-0.628-25.782l-24.597-7.752c-1.375-0.433-1.408-2.368-0.047-2.847l24.326-8.564l-0.228-25.789 C275.286,211.167,277.116,210.539,277.992,211.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M191.379,325.906c-44.139,0-79.945-35.806-79.945-79.985c0-44.098,35.806-79.984,79.945-79.984 c16.422,0,31.567,5.051,44.187,13.599c1.933,1.309,4.139-1.231,2.52-2.913c-18.862-19.611-45.559-31.574-75.158-30.564 c-50.853,1.735-92.952,42.507-96.201,93.286c-3.722,58.163,42.332,106.499,99.672,106.499c28.245,0,53.629-11.808,71.757-30.688 c1.602-1.668-0.609-4.169-2.523-2.872C222.999,320.849,207.83,325.906,191.379,325.906z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurkey);
export default __webpack_public_path__ + "static/media/turkey.5c4498fd2093ff78577bfd78cd0c9827.svg";
export { ForwardRef as ReactComponent };